import { BatchUpdateOrdersParams } from '../../../interfaces/orderBatchRepository.interfaces';
import { OrderListTabName, getOrderStatusByTab } from '../../../list/orderListTabs';
import { StatusType } from '../../../order.types';
import { ExportOrderScope, ExportScope } from '../ExportOrderModal.types';

type PdfScopeBody = { orderIds: string[] } | { filters: Record<string, unknown> };

const decideExportScope = (batch: BatchUpdateOrdersParams): ExportScope => {
  const hasFilter =
    Boolean(batch.allOrdersFromMassActions) ||
    (batch.filter && Object.keys(batch.filter).length > 0);

  return hasFilter
    ? { type: 'filters', filters: batch.filter ?? {} }
    : { type: 'ids', ids: batch.orderIds ?? [] };
};

export const mapPdfScope = (scope: ExportScope, selectedTab?: OrderListTabName): PdfScopeBody => {
  if (scope.type === 'ids') {
    return { orderIds: scope.ids };
  }

  const status = !!scope.filters?.status
    ? (scope.filters.status as StatusType | StatusType[])
    : getOrderStatusByTab(selectedTab);

  return { filters: { ...scope.filters, status: status.length ? status : undefined } };
};

export const mapCsvScope = (scope: ExportScope): { ids: string[] } & Record<string, unknown> => {
  if (scope.type === 'ids') {
    return { ids: scope.ids };
  }

  return { ids: [], ...(scope.filters ?? {}) };
};

export const createExportOrderScope = (scope: ExportScope): ExportOrderScope => ({
  scope,
  isSyncExport: scope.type === 'ids' && scope.ids.length === 1,
});

export const createExportOrderScopeFromBatch = (batch: BatchUpdateOrdersParams): ExportOrderScope =>
  createExportOrderScope(decideExportScope(batch));
